import { Component, OnInit, OnDestroy } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { EmitterService } from '../services/emitter.service';
import { Router } from '@angular/router';
import { AppDetailsService } from './../services/app-details.services';
import { CountryDataService } from '../services/country.service';
import { environment } from '../../environments/environment';
import { AjaxService } from '../services/ajax.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
@Component({
  selector: 'app-footer-createaccount-block',
  templateUrl: './footer-createaccount-block.component.html',
  styleUrls: ['./footer-createaccount-block.component.scss']
})
export class FooterCreateaccountBlockComponent implements OnInit, OnDestroy {
  isUserLoggedIn: boolean = false;
  langCode;
  isCountryAllowed: number = 0;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private utils: Utility,
    private emitterService: EmitterService,
    private ajaxService: AjaxService,
    private router: Router,
    private appDetails: AppDetailsService,
    private countryDataService: CountryDataService
  ) {
   this.isUserLoggedIn = this.utils.isUserLoggedIn();
   this.langCode = localStorage.getItem('langCode')
   this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
     this.langCode = langCode;
   });

   this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isUserLoggedIn = loginStatus;
  });
 }
  goToregStep1() {
  /* checking user login status, if user is already logged in, loading the homepage else going with registration flow */
    Promise.resolve(this.ajaxService.getLoginStatus()).then(data => {
      if (data['status']) {
        this.appDetails.loadHomepage(this.langCode);
      }
      else {
        this.router.navigate([this.langCode + '/register/step1'], { queryParams: { "prevUrl": window.location.pathname } })
      }
    });
 }
 goToPromotion(){
   this.router.navigate([this.langCode+'/promotions'])
 }
 goToTrustlyReg() {
  this.router.navigate([this.langCode+'/playnow/step1'])
 }
  ngOnInit() {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.getCountry();
  }
  getCountry(country?: String) {
    if (environment.trustlyCountries.indexOf(this.countryDataService.ipCountry.toUpperCase()) >= 0) {
      this.isCountryAllowed = 1;
      this.appDetails.country = this.countryDataService.ipCountry;
      setTimeout(() => {
        this.emitterService.broadcastsetCountryCurrency(country);
      }, 100);
    } else {
      this.isCountryAllowed = 2;
      this.appDetails.country = null;
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
